import { Directive, Input, TemplateRef, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[ceresWizardForm]',
    standalone: false
})
export class WizardFormDirective {
    readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);

    @Input('ceresWizardForm')
    title!: string;

    @Input('ceresWizardFormFormGroup')
    formGroup!: FormGroup;
}
